import { Button, Typography } from '@zeptonow/zui';
import Breadcrumb from '@zeptonow/zui/Breadcrumb';
import LogoutComponent from '../../auth/Logout';
import useEntitySelectionModal from '../../hooks/useEntitySelectionModal';
import { UserStore } from '../../store';
import { generateImage } from '../../utilities/utils';
import SubHeader from '../sub-header';
import BreadcrumbItems from './BreadcrumbItems';

const Header = () => {
  const entityCode = UserStore((state) => state.entityCode);
  const entityCodesList = UserStore((state) => state.entityCodesList);

  const { openEntityModal } = useEntitySelectionModal();

  const showEntitySelectionModal =
    Array.isArray(entityCodesList) && entityCodesList.length > 1;

  const handleEntityChange = () => {
    if (showEntitySelectionModal) {
      openEntityModal();
    }
  };

  const leftWidget = () => <Breadcrumb items={BreadcrumbItems()} />;
  const rightWidget = () => (
    <div className="flex justify-between gap-4 items-center">
      {entityCode && (
        <Button
          disabled={!showEntitySelectionModal}
          variant="outlined"
          className={`rounded-md border border-gray-300 px-3 py-2 flex items-center gap-2`}
          onClick={handleEntityChange}
        >
          {generateImage({
            name: 'building-06',
            alt: 'building-icon',
            className: 'w-4 h-4',
          })}
          <Typography className="!text-gray-700 !text-sm !font-medium">
            {entityCode}
          </Typography>
        </Button>
      )}

      <LogoutComponent />
    </div>
  );

  return (
    <SubHeader
      rightWidget={rightWidget}
      leftWidget={leftWidget}
      className="px-5 bg-white items-center w-full h-full border-b border-gray-200 min-h-[4rem]"
    />
  );
};

export default Header;
